export default "__VITE_ASSET__2vKHHI2w__"